export const resolveRequestNeedsLoan = (request) => {
  if (!request) return false;
  const value = request.needsLoan ?? request.NeedsLoan;
  return value === true || value === "true" || value === 1 || value === "1";
};

export const normalizeLoanMehrsanStageGate = (raw, { needsLoanFallback = false } = {}) => {
  const data = raw?.data ?? raw?.Data ?? raw ?? {};
  const hasLoanRequiredField =
    data.loanRequired !== undefined ||
    data.LoanRequired !== undefined;
  const apiLoanRequired = Boolean(data.loanRequired ?? data.LoanRequired ?? false);
  const loanRequired = hasLoanRequiredField
    ? apiLoanRequired || needsLoanFallback
    : needsLoanFallback;

  const hasLoanCompleteField =
    data.loanComplete !== undefined || data.LoanComplete !== undefined;
  const apiLoanComplete = Boolean(data.loanComplete ?? data.LoanComplete ?? false);

  return {
    mehrsanRequired: data.mehrsanRequired ?? data.MehrsanRequired ?? true,
    mehrsanComplete: Boolean(
      data.mehrsanComplete ?? data.MehrsanComplete ?? false
    ),
    mehrsanBlockReason:
      data.mehrsanBlockReason ?? data.MehrsanBlockReason ?? "",
    mehrsanOpenCount: Number(
      data.mehrsanOpenCount ?? data.MehrsanOpenCount ?? 0
    ),
    loanRequired,
    loanComplete: loanRequired
      ? hasLoanCompleteField
        ? apiLoanComplete
        : false
      : true,
    loanBlockReason: data.loanBlockReason ?? data.LoanBlockReason ?? "",
    loanOpenCount: Number(data.loanOpenCount ?? data.LoanOpenCount ?? 0),
    canProceedToOperational: Boolean(
      data.canProceedToOperational ?? data.CanProceedToOperational ?? false
    ),
    blockingReason: data.blockingReason ?? data.BlockingReason ?? "",
    lendingCreditValidationApproved: Boolean(
      data.lendingCreditValidationApproved ??
        data.LendingCreditValidationApproved ??
        false
    ),
    canAssignSiteVisit: Boolean(
      data.canAssignSiteVisit ?? data.CanAssignSiteVisit ?? false
    ),
    siteVisitAssignmentBlockReason:
      data.siteVisitAssignmentBlockReason ??
      data.SiteVisitAssignmentBlockReason ??
      "",
    canStartMehrsanOperations: Boolean(
      data.canStartMehrsanOperations ?? data.CanStartMehrsanOperations ?? false
    ),
    siteVisitOutcomeRecorded: Boolean(
      data.siteVisitOutcomeRecorded ?? data.SiteVisitOutcomeRecorded ?? false
    ),
    siteVisitApproved: Boolean(
      data.siteVisitApproved ?? data.SiteVisitApproved ?? false
    ),
    canTerminateDueToSiteVisitRejection: Boolean(
      data.canTerminateDueToSiteVisitRejection ??
        data.CanTerminateDueToSiteVisitRejection ??
        false
    ),
    siteVisitOutcomeStatusTitle:
      data.siteVisitOutcomeStatusTitle ?? data.SiteVisitOutcomeStatusTitle ?? "",
    siteVisitOutcomeBlockReason:
      data.siteVisitOutcomeBlockReason ?? data.SiteVisitOutcomeBlockReason ?? "",
    isAwaitingDistributionReview: Boolean(
      data.isAwaitingDistributionReview ??
        data.IsAwaitingDistributionReview ??
        false
    ),
    siteVisitSupervisorDescription:
      data.siteVisitSupervisorDescription ??
      data.SiteVisitSupervisorDescription ??
      "",
  };
};

export const mergeLoanMehrsanGateWithRequest = (gate, request) => {
  const needsLoan = resolveRequestNeedsLoan(request);
  if (!gate) {
    return {
      mehrsanRequired: true,
      mehrsanComplete: false,
      mehrsanBlockReason: "",
      mehrsanOpenCount: 0,
      loanRequired: needsLoan,
      loanComplete: !needsLoan,
      loanBlockReason: needsLoan ? "فرآیند وام باید ثبت و تکمیل شود." : "",
      loanOpenCount: 0,
      canProceedToOperational: false,
      blockingReason: "",
      lendingCreditValidationApproved: !needsLoan,
      canAssignSiteVisit: !needsLoan,
      siteVisitAssignmentBlockReason: needsLoan
        ? "پس از تأیید اعتبارسنجی متقاضی توسط لندتک، امکان ارجاع بازدید فعال می‌شود."
        : "",
      canStartMehrsanOperations: false,
      siteVisitOutcomeRecorded: false,
      siteVisitApproved: false,
      canTerminateDueToSiteVisitRejection: false,
      siteVisitOutcomeStatusTitle: "",
      siteVisitOutcomeBlockReason:
        "تا زمان ثبت نتیجه بازدید اولیه توسط ناظر، امکان شروع عملیات مهرسان وجود ندارد.",
      siteVisitSupervisorDescription: "",
    };
  }

  if (needsLoan && !gate.loanRequired) {
    const loanComplete = Boolean(gate.loanComplete);
    const mehrsanComplete = Boolean(gate.mehrsanComplete);
    return {
      ...gate,
      loanRequired: true,
      loanComplete,
      loanBlockReason: loanComplete
        ? ""
        : gate.loanBlockReason ||
          "برای این پرونده فرآیند وام باید ثبت و تکمیل شود.",
      canProceedToOperational: Boolean(mehrsanComplete && loanComplete),
      blockingReason:
        mehrsanComplete && loanComplete
          ? ""
          : gate.blockingReason ||
            "برای ورود به برنامه عملیاتی، تکمیل مهرسان و وام الزامی است.",
    };
  }

  return gate;
};

export const buildLoanMehrsanGateSummaryLines = (gate) => {
  if (!gate) return [];
  const lines = [];
  lines.push({
    key: "mehrsan",
    label: "مهرسان",
    complete: gate.mehrsanComplete,
    detail: gate.mehrsanComplete
      ? "تکمیل شده"
      : gate.mehrsanBlockReason || "در انتظار تکمیل",
  });
  if (gate.loanRequired) {
    lines.push({
      key: "loan",
      label: "وام",
      complete: gate.loanComplete,
      detail: gate.loanComplete
        ? "تکمیل شده"
        : gate.loanBlockReason || "در انتظار تکمیل",
    });
  }
  return lines;
};
